module.exports = __webpack_public_path__ + "img/futvolei.3270b6e3.png";